"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledFileInput = exports.Styled = void 0;

var _styles = require("../../../components/Button/styles");

var _styledComponents = require("styled-components");

var _theme = require("../../../theme");

var _utils = require("../../../utils");

var _input = require("./input.inject");

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n    &:hover {\n      box-shadow: none;\n    }\n  "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n    &:active {\n      box-shadow: none;\n    }\n  "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  border-radius: 0;\n  border: none;\n\n  ", "\n\n  ", "\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n    &:hover,\n    &:focus-within {\n      border-right: none;\n    }\n  "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n    &:active {\n      border-right: none;\n    }\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  border-radius: 0;\n  cursor: pointer;\n  border-right: none;\n\n  ", "\n\n  ", "\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    width: 100%;\n\n    display: flex;\n    align-items: stretch;\n\n    border-radius: var(--border-radius);\n    cursor: pointer;\n\n    overflow: hidden;\n    position: relative;\n\n    transition: var(--transition);\n\n    ", ";\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2;\n\n  cursor: pointer;\n\n  &[disabled] {\n    cursor: not-allowed;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    cursor: pointer;\n\n    flex: 1;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    border: none;\n\n    ", ";\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n\n    width: 100%;\n    ", ";\n\n    border-radius: var(--border-radius);\n    ", ";\n    background-color: var(--c-lightest);\n\n    overflow: hidden;\n    position: relative;\n\n    transition: var(--transition);\n\n    &:after {\n      content: '';\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      z-index: 3;\n\n      width: 100%;\n      height: 1px;\n\n      background-color: var(--c-primary);\n\n      transform: scaleX(0);\n      transform-origin: left;\n      transition: transform var(--transition);\n    }\n\n    ", ";\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  margin-top: -1px;\n\n  ", ";\n\n  transition: var(--transition);\n\n  &::-webkit-inner-spin-button {\n    display: none;\n  }\n\n  &::placeholder {\n    color: var(--c-neutral);\n    transition: var(--transition);\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin-right: 0;\n  margin-left: var(--i-regular);\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n\n  display: flex;\n  align-items: center;\n\n  flex: 0;\n  margin-right: var(--i-regular);\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Prefix = (0, _utils.sc)('div')((0, _styledComponents.css)(_templateObject(), _theme.Mixin.Font.bodySmall()))('Prefix');
var Suffix = (0, _utils.sc)(Prefix)((0, _styledComponents.css)(_templateObject2()))('Suffix');
var Input = (0, _utils.sc)('input')((0, _styledComponents.css)(_templateObject3(), _theme.Mixin.Font.bodyRegular()))('Input');
var InputContainer = (0, _utils.sc)('div')(function (_ref) {
  var isDisabled = _ref.isDisabled;
  return (0, _styledComponents.css)(_templateObject4(), _theme.Mixin.Style.inputPadding(), _theme.Mixin.Style.borderAll({
    color: 'var(--c-neutral)'
  }), _input.inject.inputContainerDisabledStyles({
    isDisabled: isDisabled,
    Input: Input
  }));
})('InputContainer');
var FileInput = (0, _utils.sc)(Input)(function (_ref2) {
  var value = _ref2.value;
  return (0, _styledComponents.css)(_templateObject5(), _input.inject.fileInputColorToggle(value));
})('FileInput');
var HiddenFileInput = (0, _utils.sc)('input')((0, _styledComponents.css)(_templateObject6()))('HiddenFileInput');
var FileInputWrapper = (0, _utils.sc)('div')(function (_ref3) {
  var isDisabled = _ref3.isDisabled;
  return (0, _styledComponents.css)(_templateObject7(), _input.inject.fileInputWrapperDisabledStyles(isDisabled));
})('FileInputWrapper');
var FileInputContainer = (0, _utils.sc)(InputContainer)((0, _styledComponents.css)(_templateObject8(), _theme.Mixin.Device.mobile((0, _styledComponents.css)(_templateObject9())), _theme.Mixin.Device.desktop((0, _styledComponents.css)(_templateObject10()))))('FileInputContainer');
var FileInputButton = (0, _utils.sc)(_styles.Styled.Button)((0, _styledComponents.css)(_templateObject11(), _theme.Mixin.Device.mobile((0, _styledComponents.css)(_templateObject12())), _theme.Mixin.Device.desktop((0, _styledComponents.css)(_templateObject13()))))('FileInputButton');
var Styled = {
  InputContainer: InputContainer,
  Input: Input,
  Prefix: Prefix,
  Suffix: Suffix
};
exports.Styled = Styled;
var StyledFileInput = {
  HiddenFileInput: HiddenFileInput,
  FileInput: FileInput,
  FileInputButton: FileInputButton,
  FileInputContainer: FileInputContainer,
  FileInputWrapper: FileInputWrapper,
  Prefix: Prefix,
  Suffix: Suffix
};
exports.StyledFileInput = StyledFileInput;